import logo from "../images/AbsorbX..svg";
import info_image from "../images/info_image.png";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FiShoppingCart, FiUsers, FiFileText, FiUser } from "react-icons/fi";
import { LuClipboardList } from "react-icons/lu";
import { RiLeafLine } from "react-icons/ri";
import { useAuth } from "../context/AuthContext";
function Sidebar({ toggleClick, sidebarToggle }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;

  const LogoutHndler = () => {
    navigate("/");
    localStorage.removeItem("useremail");
    toast.success("Logout successful !");
  };

  return (
    <>
      <input
        type="checkbox"
        id="check"
        checked={sidebarToggle}
        onChange={toggleClick}
      />
      <label htmlFor="check">
        <i className="fas fa-bars" id="btn"></i>
        <i className="fas fa-times" id="cancel"></i>
      </label>
      <div className="sidebar font-[Poppins] flex flex-col justify-between fixed 2xl:w-[300px] w-[250px]   h-screen 2xl:left-[-300px] left-[-250px]  border bg-[white] shadow-sm ">
        <div className=" p-5 pl-5">
          <img className="2xl:w-36 w-20" src={logo} alt="" />

          {user?.role === "admin" && (
            <NavLink
              to="/admin-allorders"
              className="flex gap-3 items-center text-[#9197B3] mt-10  py-2 pl-2 rounded-lg"
            >
              <FiShoppingCart className="2xl:text-xl text-base" />
              <span className="max-2xl:text-sm">All Orders</span>
            </NavLink>
          )}

          {user?.role === "admin" && (
            <NavLink
              to="/customers"
              className="flex gap-3 items-center text-[#9197B3] mt-5  py-2 pl-2 rounded-lg"
            >
              <FiUsers className="2xl:text-xl text-base" />
              <span className="max-2xl:text-sm">Customer</span>
            </NavLink>
          )}

          {user?.role === "user" && (
            <NavLink
              to="/myorder"
              className="flex gap-3 items-center text-[#9197B3] mt-5  py-2 pl-2 rounded-lg"
            >
              <FiShoppingCart className="2xl:text-xl text-base" />
              <span className="max-2xl:text-sm">My Orders</span>
            </NavLink>
          )}

          {user?.role === "admin" && (
            <NavLink
              to="/project"
              className="flex gap-3 items-center text-[#9197B3] mt-5  py-2 pl-2 rounded-lg"
            >
              <FiFileText className="2xl:text-xl text-base" />
              <span className="max-2xl:text-sm">Project</span>
            </NavLink>
          )}

          {user?.role === "user" && (
            <NavLink
              to="/profile"
              className="flex gap-3 items-center text-[#9197B3] mt-5  py-2 pl-2 rounded-lg"
            >
              <FiUser className="2xl:text-xl text-base" />
              <span className="max-2xl:text-sm">My Profile</span>
            </NavLink>
          )}
          {user?.role === "admin" && (
            <NavLink
              to="/methodologie"
              className="flex gap-3 items-center text-[#9197B3] mt-5  py-2 pl-2 rounded-lg"
            >
              <LuClipboardList className="2xl:text-xl text-base" />
              <span className="max-2xl:text-sm">Methodology</span>
            </NavLink>
          )}
          {user?.role === "admin" && (
            <NavLink
              to="/carbonremovel"
              className="flex gap-3 items-center text-[#9197B3] mt-5  py-2 pl-2 rounded-lg"
            >
              <RiLeafLine className="2xl:text-xl text-base" />
              <span className="max-2xl:text-sm">Carbon removal</span>
            </NavLink>
          )}
          {user?.role === "admin" && (
            <NavLink
              to="/admin-profile"
              className="flex gap-3 items-center text-[#9197B3] mt-5  py-2 pl-2 rounded-lg"
            >
              <FiUser className="2xl:text-xl text-base" />
              <span className="max-2xl:text-sm">My Profile</span>
            </NavLink>
          )}
        </div>

        <div className="mb-10  mx-5">
          <img src={info_image} alt="" />

          <div className="text-left pt-5 max-2xl:text-sm">
            <button
              onClick={LogoutHndler}
              className="bg-[#C65B1D]   hover:shadow-md button 2xl:px-5 px-3 2xl:py-2 py-[0.40rem] rounded-lg text-white"
            >
              Logout <i className="fa-solid fa-right-from-bracket ml-1"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
